












import Vue               from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {Payer}           from '@/types'
import {logout}          from '@/common/api'
import {document}        from '@/common/helpers'

@Component
export default class Navbar extends Vue {
    @Prop({type: Object as () => Payer})
    protected payer!: Payer

    protected get name() {
        const {name, nickname} = this.payer
        const result = nickname || name
        if (!result) {
            return ''
        }
        if (result.length < 20) {
            return nickname
        }
        const [firstName, secondName] = result.split(' ')
        return `${firstName} ${secondName || ''}`.trim()
    }

    protected get document() {
        return document(this.payer.document)
    }

    protected logout() {
        logout()
        this.$router.push({name: 'login'})
    }
}
